import type { _LoginInfoParams } from 'autogen/swagger/all';
import OpenLoginModal from 'components/login/shared/helpers';
import type { LinkAction } from 'components/shared/Routing/components/LinkAction/shared/types';
import type { ProductActionProps } from '../../shared/types';

async function GoToProductReviewSection({
    productId,
    productNavigationLink,
    isAuthenticated
}: {
    productId: number;
    productNavigationLink: LinkAction;
    isAuthenticated?: boolean;
}) {
    if (!isAuthenticated) {
        const loginParams: _LoginInfoParams = {
            productId,
            infoType: 'WriteReview',
            level: 'Soft',
            mode: 'Standard',
            returnUrl: productNavigationLink.url // should be replaced with productReviewUrl look at GetProductReviewUrl()
        };

        return OpenLoginModal(loginParams);
    }

    // TODO nkr NAvigationLink er det her rigtigt?
    window.location.href = productNavigationLink.url; // should be replaced with productReviewUrl look at GetProductReviewUrl()
}

export default async function openWriteReview({ params, trackingInfo }: ProductActionProps['WriteReview']) {
    await GoToProductReviewSection(params);
}
